module.exports = __webpack_public_path__ + "img/calendar.22cb3431.svg";